import React from "react";
import { Link, useNavigate  } from "react-router-dom";
import { FaShoppingCart, FaUser } from "react-icons/fa";

export default function Navbar() {
    const navigate = useNavigate();

    const handleSelectChange = (e) => {
        if (e.target.value !== '') {
            navigate(e.target.value);
        }
    };
    return (
        <header className="pb-4 pl-7 pr-6">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
                <div className="flex items-center ml-3 space-x-3">
                    <img src="logo.png" alt="" className="h-8 w-8 object-contain" />
                    <div className="flex flex-col leading-none">
                        <span className="text-[20px] font-rajdhani font-semibold tracking-tighter uppercase ">Fitness</span>
                        <span className="text-[20px] -mt-1 font-rajdhani font-semibold tracking-tighter uppercase leading-none">La<span className="text-lime-500">tour</span></span>
                    </div>     
                </div>
                <div className="flex space-x-3 items-center">
                    <nav className="hidden md:flex space-x-6 uppercase text-sm ">
                        <select
                          onChange={handleSelectChange}
                          defaultValue=""
                          className="bg-transparent text-white border-none focus:outline-none cursor-pointer"
                        >
                          <option value="" disabled>NOS COURS</option>
                          <option value="/cours/cardio">Cardio</option>
                          <option value="/cours/musculation">Musculation</option>
                          <option value="/cours/collectif">Collectif</option>
                        </select>
                        <select
                          onChange={handleSelectChange}
                          defaultValue=""
                          className="bg-transparent text-white border-none focus:outline-none cursor-pointer"
                        >
                          <option value="" disabled>NEWS SERVICES</option>
                          <option value="/news">News</option>
                          <option value="/services">Services</option>
                        </select>
                        <select
                          onChange={handleSelectChange}
                          defaultValue=""
                          className="bg-transparent text-white border-none focus:outline-none cursor-pointer"
                        >
                          <option value="" disabled>SUR NOUS</option>
                          <option value="/equipe">Notre équipe</option>
                          <option value="/vision">Notre vision</option>
                        </select>
                        <Link to="/contact" className="hover:text-lime-400">Contact</Link>
                        <Link to="/essai" className="hover:text-lime-400">Séance d’essai</Link>
                    </nav>
                    <div className="flex items-center space-x-4 text-sm ">
                      <Link
                        to="/achat"
                        className="flex items-center gap-2 bg-lime-400 text-white px-4 py-2 hover:bg-lime-500 transition"
                      >
                        <FaShoppingCart /> ACHAT ABO
                      </Link>
                      <Link to="/espace-membre" className="flex items-center gap-2 text-lime-400 hover:text-lime-300">
                        <FaUser /> ESPACE MEMBRE
                      </Link>
                    </div>
                </div>
            </div>
        </header>
    )
}